import Vue from "vue";
import VueI18n from "vue-i18n";
Vue.use(VueI18n);

// 引入自己应用需要支持语言配置文件
import zh from "./zh.js";
import en from "./en.js";

// 引入element的语言包
import ElementLocale from "element-ui/lib/locale";
import enLocale from "element-ui/lib/locale/lang/en";
import cnLocale from "element-ui/lib/locale/lang/zh-CN";

const i18n = new VueI18n({
  // 设置默认语言
  locale: window.localStorage.getItem("lang") || "cn",
  messages: {
    zh: {
      ...cnLocale,
      ...zh,
    },
    en: {
      ...enLocale,
      ...en,
    },
  },
});

ElementLocale.i18n((key, value) => i18n.t(key, value));
export default i18n;



// WEBPACK FOOTER //
// ./src/language/index.js